<template>
  <div class="col-6 col-sm-3 col-xl-2 p-0" :id="getId">
    <div class="card text-center p-0">
      <div class="card-header text-light bd-navbar d-flex justify-content-center p-2">
        <h5>
          <a class="text-light" :href="provider.homepage">{{provider.name}}</a>
        </h5>
        <div v-if="provider.icon" class="pl-2">
          <img class="i42Icon" :src="provider.icon" />
        </div>
      </div>
      <content-static-provider-error v-if="hasError" v-on:reload="tuerOpener" />

      <content-static-provider-item v-for="item in feed" v-bind:key="item.id" :news="item" />

      <content-static-provider-more v-if="hasMoreArticles" v-on:more="nextArticles" />

      <content-static-provider-wait v-if="isLoading" />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import ContentStaticProviderWait from "@/components/ContentStaticProviderWait.vue";
import ContentStaticProviderError from "@/components/ContentStaticProviderError.vue";
import ContentStaticProviderItem from "@/components/ContentStaticProviderItem.vue";
import ContentStaticProviderMore from "@/components/ContentStaticProviderMore.vue";

import { Plugins } from "@capacitor/core";
import "tuer-plugin";

const { TuerPlugin } = Plugins;

export default {
  name: "ContentStaticProvider",

  data: function() {
    return {
      isLoading: false,
      hasError: false,
      showArticles: 5,
      providerFeed: {},
    };
  },

  props: {
    provider: {}
  },

  computed: {
    getId: function() {
      return "p" + this.provider.id;
    },
    currentFeedFromStore: function() {
      let providerUrl = this.provider.url;
      let providerResult = this.$store.state.content.find(function(data) {
        return data.url == providerUrl;
      });

      if (providerResult === undefined) return { feed: []};
      else return providerResult;
    },
    hasMoreArticles: function() {
      return this.currentFeedFromStore.feed.length > this.showArticles;
    },
    feed: function() {
      if (this.currentFeedFromStore.feed === undefined) return [];
      else {
       return this.currentFeedFromStore.feed.slice(0, this.showArticles);
      }
    },
    getBaseUrl: function() {
      //return 'http://localhost:8080/dist/';
      return "https://www.indie42.de/dist/";
      // var locationPath = window.location.pathname.split("/");
      // locationPath.splice(locationPath.length - 1, 1);
      // return (
      //   window.location.protocol +
      //   "//" +
      //   window.location.host +
      //   locationPath.join("/") +
      //   "/"
      // );
    }
  },
  components: {
    ContentStaticProviderWait,
    ContentStaticProviderError,
    ContentStaticProviderItem,
    ContentStaticProviderMore
  },

  methods: {
    tuerOpener: function() {
      this.isLoading = true;
      this.hasError = false;

      TuerPlugin.echo({ mode: "parse", value: this.provider.url })
        .then(ret => {
          this.$store.dispatch("setContent", {
            url: this.provider.url,
            feed: ret.value.feed
          });
        })
        .catch((/*error*/) => {
          //this.debugText = error.message;
          this.hasError = true;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    nextArticles: function() {
      this.showArticles += 5;
    },
    loadFeed: function() {
      this.isLoading = true;
      this.hasError = false;

      let providerUrl = this.provider.url;

      let requestURL =
        this.getBaseUrl +
        "news.php?v=2&i=1&q=" +
        providerUrl;

      axios
        .get(requestURL, {
          //headers: {
          //  "Access-Control-Allow-Origin": "*"
          //},
          responseType: "json"
        })
        .then(response => {
          if (response == "") {
            this.hasError = true;
          } else {
            this.$store.dispatch("setContent", {
              url: providerUrl,
              feed: response.data.feed
            });
          }
        })
        .catch((/*error*/) => {
          //console.log(error);
          this.hasError = true;
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },
  mounted() {
    if (this.currentFeedFromStore.feed.length == 0) this.tuerOpener();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bd-navbar {
  background-color: #563d7c;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.05),
    inset 0 -1px 0 rgba(0, 0, 0, 0.1);
}
.i42Icon {
  max-height: 20px;
  width: auto;
}
</style>
